var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',[_c('div',[_c('ChartComponent',[_c('MealRate',{attrs:{"meal":_vm.meal}})],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }